import { MouseEventHandler } from 'react'

import { createStyles } from 'antd-style'

import { pick } from '@eastcoal/common/utils/object'

import { useContractDesignerStore } from '../../../designer/Store/hooks/useStore'

import { TextVariablePlaceholderProps } from './interface'

const useStyles = createStyles(({ token }) => ({
  placeholder: {
    marginInline: 2,
    paddingBlock: 1,
    borderWidth: 1,
    borderStyle: 'dashed',
    borderColor: token.colorError,
    borderRadius: token.borderRadiusXS,
    backgroundColor: token.colorErrorBgActive,
    cursor: 'pointer',
    ['&.is-selected']: {
      backgroundColor: token.colorPrimaryBg,
      borderColor: token.colorPrimaryBorder
    }
  }
}))

export const TextVariablePlaceholder = ({
  nodeKey,
  variable: { name },
  styleConfig
}: TextVariablePlaceholderProps) => {
  const { activedVariableNodeKey, setActivedVariableNodeKey } =
    useContractDesignerStore(state =>
      pick(state, ['activedVariableNodeKey', 'setActivedVariableNodeKey'])
    )
  const isSelected = activedVariableNodeKey === nodeKey

  const handleClick: MouseEventHandler<HTMLSpanElement> = event => {
    // 防止事件冒泡到编辑器导致 selection 变为 null
    event.stopPropagation()
    setActivedVariableNodeKey(isSelected ? undefined : nodeKey)
  }

  const { cx, styles } = useStyles()

  return (
    <span
      role='button'
      style={styleConfig}
      tabIndex={0}
      className={cx(styles.placeholder, {
        'is-selected': isSelected
      })}
      onClick={handleClick}
    >
      &nbsp;{name}&nbsp;
    </span>
  )
}
